<template>
    <div class="case-box" ref="applocation">
        <el-row class="mb-54">
            <el-col :span="21" :offset="3">
                <div class="nav-title">
                    <span>案例展示</span>
                    <span>/</span>
                    <span>Applications</span>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <!-- tab 导航 -->
            <el-col :span="20" :offset="3">
                <el-row :gutter="10" class="mb-54">
                    <el-col :span="3" v-for="(item, index) in tabList" :key="index">
                        <div :class="['tab-btn', index == tabIndex ? 'tab-btn-select' : '']" @click="clickTab(index)">
                            <div>{{ item.name }}</div>
                            <div class="line"></div>
                        </div>
                    </el-col>
                </el-row>
                <!-- 案例 -->
                <el-row :gutter="10">
                    <el-col v-for="(item, index) in caseData" :span="7" :key="index">
                        <div class="case-item">
                            <el-image :src="item.imgUrl" fit="cover" :preview-src-list="imgUrls"></el-image>
                            <p>{{ item.title }}</p>
                        </div>

                    </el-col>
                </el-row>
            </el-col>
        </el-row>

    </div>
</template>

<script>
import { EventBus } from '../js/eventBus';
export default {
    name: 'Applocation',
    props:['winWidth'],
    data() {
        return {
            tabList: [
                {
                    name: '办公室装修工程',
                    data: [
                        { title: '紫金数码大厦4号楼104', imgUrl: require('../assets/case_images/office_room/1.png') },
                        { title: '紫金数码大厦4号楼104', imgUrl: require('../assets/case_images/office_room/2.png') },
                        { title: '紫金数码大厦4号楼104', imgUrl: require('../assets/case_images/office_room/3.png') },
                        { title: '中关村银网中心大厦16层', imgUrl: require('../assets/case_images/office_room/4.png') },
                        { title: '中关村银网中心大厦16层', imgUrl: require('../assets/case_images/office_room/5.png') },
                        { title: '中关村银网中心大厦16层', imgUrl: require('../assets/case_images/office_room/6.png') },
                    ]
                },
                {
                    name: '餐饮店装修工程',
                    data: [
                        { title: '馋猫餐厅', imgUrl: require('../assets/case_images/catering/1.jpg') },
                        { title: '馋猫餐厅', imgUrl: require('../assets/case_images/catering/2.jpg') },
                        { title: '能量伙夫大厅', imgUrl: require('../assets/case_images/catering/3.jpg') },
                        { title: '能量伙夫前厅', imgUrl: require('../assets/case_images/catering/4.jpg') },
                        { title: '能量伙夫主厅', imgUrl: require('../assets/case_images/catering/5.jpg') },
                        { title: '能两伙夫外厅', imgUrl: require('../assets/case_images/catering/6.jpg') },
                    ]
                },
                {
                    name: '仓储装修工程',
                    data: [
                        { title: '顺丰集团-仓储', imgUrl: require('../assets/case_images/storage/1.jpg') },
                        { title: '顺丰集团-仓储', imgUrl: require('../assets/case_images/storage/2.jpg') },
                        { title: '顺丰集团-仓储', imgUrl: require('../assets/case_images/storage/3.jpg') },
                        { title: '顺丰集团-仓储', imgUrl: require('../assets/case_images/storage/4.jpg') },
                    ]
                },
                {
                    name: '培训机构装修',
                    data: [
                        { title: '双语幼儿园', imgUrl: require('../assets/case_images/training/1.jpg') },
                        { title: '双语幼儿园', imgUrl: require('../assets/case_images/training/2.jpg') },
                        { title: '双语幼儿园', imgUrl: require('../assets/case_images/training/2_1.jpg') },
                        { title: '月儿湾培训中心', imgUrl: require('../assets/case_images/training/3.jpg') },
                        { title: '月儿湾培训中心', imgUrl: require('../assets/case_images/training/4.jpg') },
                        { title: '月儿湾培训中心', imgUrl: require('../assets/case_images/training/5.jpg') },
                    ]
                },
                {
                    name: '商场装修工程',
                    data: [
                        { title: '268音乐基地', imgUrl: require('../assets/case_images/shop/1.png') },
                        { title: '268音乐基地', imgUrl: require('../assets/case_images/shop/2.png') },
                        { title: '268音乐基地', imgUrl: require('../assets/case_images/shop/3.png') },
                        { title: '北京商场', imgUrl: require('../assets/case_images/shop/4.jpg') },
                        { title: '北京商场', imgUrl: require('../assets/case_images/shop/5.jpg') },
                        { title: '北京商场', imgUrl: require('../assets/case_images/shop/6.jpg') },
                    ]
                },
                {
                    name: '售楼处装修工程',
                    data: [
                        { title: '泊头售楼处', imgUrl: require('../assets/case_images/sales_office/1.png') },
                        { title: '泊头售楼处', imgUrl: require('../assets/case_images/sales_office/2.png') },
                        { title: '泊头售楼处', imgUrl: require('../assets/case_images/sales_office/3.png') },
                        { title: '壹号院售楼处', imgUrl: require('../assets/case_images/sales_office/4.jpg') },
                        { title: '壹号院售楼处', imgUrl: require('../assets/case_images/sales_office/5.jpg') },
                        { title: '壹号院售楼处', imgUrl: require('../assets/case_images/sales_office/6.jpg') },
                    ]
                },
                {
                    name: '医院装修',
                    data: [
                        { title: '双井中医结合医院', imgUrl: require('../assets/case_images/hospital/1.png') },
                        { title: '双井中医结合医院', imgUrl: require('../assets/case_images/hospital/2.png') },
                        { title: '香山医院', imgUrl: require('../assets/case_images/hospital/3.png') },
                        { title: '香山医院', imgUrl: require('../assets/case_images/hospital/4.jpg') },
                        { title: '牙科', imgUrl: require('../assets/case_images/hospital/5.jpg') },
                        { title: '牙科', imgUrl: require('../assets/case_images/hospital/6.jpg') },
                    ]
                },
            ],
            tabIndex: 0,
            caseData: [],
            imgUrls: [],
        }
    },

    created() {
        this.caseData = this.tabList[this.tabIndex].data;
        this.imgUrls = this.caseData.map(item => item.imgUrl);
    },
    methods: {
        clickTab(index) {
            this.tabIndex = index;
            this.caseData = this.tabList[index].data;
            this.imgUrls = this.caseData.map(item => item.imgUrl);
        },
        someOtherMethod(param) {
            const anchorElement = this.$refs['applocation'];
            if (anchorElement) {
                // anchorElement.scrollIntoView({ behavior: 'smooth' });
                console.log('--荣誉资质：：',this.winWidth.case);
                window.scrollTo({
                    top: this.winWidth.case,
                    behavior: 'smooth'
                });
            }
        }
    },
    mounted() {
        EventBus.$on('applocation', this.someOtherMethod);
    },
    beforeDestroy() {
        EventBus.$off('applocation', this.someOtherMethod);
    },
}
</script>

<style scoped lang="scss">
.case-box {
    padding: 80px 0;
}

.tab-btn {
    background: #CFA886;
    border-radius: 10px;
    text-align: center;
    font-weight: 400;
    font-size: 18px;
    color: #FFFDFB;
    line-height: 58px;
    position: relative;
    cursor: pointer;
}


.tab-btn:hover {
    background: #AD7F5A;

    .line {
        width: 70%;
        height: 2px;
        margin: 0 auto;
        background: #FFFDFB;
        position: absolute;
        bottom: 10px;
        left: 15%;
    }
}

.tab-btn-select {
    background: #AD7F5A;

    .line {
        width: 70%;
        height: 2px;
        margin: 0 auto;
        background: #FFFDFB;
        position: absolute;
        bottom: 10px;
        left: 15%;
    }
}

.case-item {
    width: 100%;
    box-shadow: 0px 0px 15px 0px rgba(75, 73, 72, 0.3);
    border-radius: 10px;
    overflow: hidden;
    text-align: center;

    img {
        margin-bottom: 10px;
    }

    p {
        line-height: 34px;
        margin-bottom: 10px;
        color: #CFA886;
        font-size: 16px;
    }

    margin-bottom: 20px;
}
</style>